// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import Flatpickr from 'stimulus-flatpickr';

const application = Application.start();
const baseContext = require.context('controllers', true, /_controller\.js$/);
const billboardContext = require.context('rp-billboard/src/controllers', true, /_controller\.js$/);

application.load(definitionsFromContext(baseContext));
application.load(definitionsFromContext(billboardContext));

application.register('flatpickr', Flatpickr);
